export interface ThemeInt {
    mode: ThemeMode
}

export enum ThemeMode{
    Light = 'light',
    Dark = 'dark'
}